import(/* webpackMode: "eager", webpackExports: ["default"] */ "/jenkins_workspace/angelai.com_workshop_nextjs/workshop-nextjs/src/components/HomeClient/HomeClient.js");
